import i18n from '@/i18n/i18n'
import RequiredDocumentService from '@/services/retailer/RequiredDocumentService'
import { errorMessage } from '@/utilities/helpers'

const { t } = i18n.global
import { APPLICATION_STATUSES } from '@/constants/constants'

export const namespaced = true

export const state = {
  requiredDocuments: [],
  publicQrUrl: null
}

export const mutations = {
  SET_REQUIRED_DOCUMENTS(state, documents) {
    state.requiredDocuments = documents
  },
  SET_PUBLIC_QR_URL(state, response) {
    state.publicQrUrl = response.url
  }
}

export const actions = {
  getRequiredDocuments({ commit }, applicationId) {
    return new Promise(resolve => {
      RequiredDocumentService.getRequiredDocuments(applicationId).then(response => {
        commit('SET_REQUIRED_DOCUMENTS', response)
        resolve(response.data)
      })
    })
  },
  uploadDocument({ commit, dispatch }, data) {
    const { applicationId, file } = data
    const formData = new FormData()

    formData.append('file', file.file)
    formData.append('type', file.type)

    return new Promise((resolve, reject) => {
      RequiredDocumentService.uploadDocument(applicationId, formData)
        .then(response => {
          const notification = {
            type: 'success',
            message: t('store.retailer.required_documents.document_successfully_uploaded')
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response.data)
        })
        .catch(err => {
          const notifications = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notifications, {
            root: true
          })
          reject(err)
        })
    })
  },
  getPublicQrCode({ commit, dispatch }, applicationId) {
    return new Promise((resolve, reject) => {
      RequiredDocumentService.getPublicQrCode(applicationId)
        .then(response => {
          commit('SET_PUBLIC_QR_URL', response)
          resolve(response.data)
        })
        .catch(err => {
          const notifications = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notifications, {
            root: true
          })
          reject(err)
        })
    })
  },
  sendUploadDocumentSMStoFarmer({ commit, dispatch }, applicationId) {
    return new Promise((resolve, reject) => {
      RequiredDocumentService.sendUploadDocumentSMStoFarmer(applicationId)
        .then(response => {
          const notification = {
            type: 'success',
            message: t('store.retailer.required_documents.sms_successfully_sent')
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response.data)
        })
        .catch(err => {
          const notifications = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notifications, {
            root: true
          })
          reject(err)
        })
    })
  },
  getPublicUploadKYCDocumentQr({ commit, dispatch }, applicationId) {
    return new Promise((resolve, reject) => {
      RequiredDocumentService.getPublicUploadKYCDocumentQr(applicationId)
        .then(response => {
          commit('SET_PUBLIC_QR_URL', response)
          resolve(response.data)
        })
        .catch(err => {
          const notifications = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notifications, {
            root: true
          })
          reject(err)
        })
    })
  },
  sendUploadKYCDocumentSMStoFarmer({ commit, dispatch }, applicationId) {
    return new Promise((resolve, reject) => {
      RequiredDocumentService.sendUploadKYCDocumentSMStoFarmer(applicationId)
        .then(response => {
          const notification = {
            type: 'success',
            message: t('store.retailer.required_documents.sms_successfully_sent')
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response.data)
        })
        .catch(err => {
          const notifications = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notifications, {
            root: true
          })
          reject(err)
        })
    })
  },
  fileUploadKYCDocument({ dispatch, commit, state }, data) {
    const { applicationId, file } = data
    const formData = new FormData()

    formData.append('file', file.file)
    formData.append('type', file.type)

    return new Promise((resolve, reject) => {
      RequiredDocumentService.uploadKycDocument(applicationId, formData)
        .then(response => {
          const notification = {
            type: 'success',
            message: t('store.retailer.required_documents.document_successfully_uploaded')
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  changeStateOfKycDocumentProcess({ commit, dispatch }, applicationId) {
    return new Promise((resolve, reject) => {
      RequiredDocumentService.transition(applicationId, APPLICATION_STATUSES.FV_DOCUMENT_APPROVAL_WAITING)
        .then(response => {
          commit('CHANGE_APPLICATION_STATUS', response.data.status)
          const notification = {
            type: 'success',
            message: t('store.admin.application.farmer_document_approval_waiting')
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  viewRequiredDocument({ dispatch, state }, params) {
    return new Promise((resolve, reject) => {
      RequiredDocumentService.viewRequiredDocument(params.applicationId, params.document, params.mimeType)
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  sendDigitalSignatureSmsToFarmer({ dispatch }, { applicationId, documentId }) {
    return new Promise((resolve, reject) => {
      RequiredDocumentService.sendDigitalSignatureSmsToFarmer(applicationId, documentId)
        .then(response => {
          if (response.success === true) {
            const notification = {
              type: 'success',
              message: t('store.retailer.required_documents.sms_successfully_sent')
            }
            dispatch('notification/add', notification, {
              root: true
            })
          }
          resolve(response)
        })
        .catch(err => {
          const notifications = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notifications, {
            root: true
          })
          reject(err)
        })
    })
  },
  verifyDigitalSignature({ dispatch }, { applicationId, documentId, code }) {
    return new Promise((resolve, reject) => {
      RequiredDocumentService.verifyDigitalSignature(applicationId, documentId, code)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          const notifications = {
            type: 'danger',
            message: errorMessage(error)
          }
          dispatch('notification/add', notifications, {
            root: true
          })
          reject(error)
        })
    })
  }
}
